import axios from "axios";
import {useState, useEffect} from 'react'
import {APIURL} from './config'


function Status(props) {

    const [results, setResults] = useState()

   
    useEffect(() => {
        liststatus()
    }, [])

    const  liststatus = async (e) => {
        
        try {
            const res = await axios.post(`${APIURL}/liststatus.php`)
            if (res.data[0].ok) {
                setResults(res.data[0].conjuntofinal)
  
            } else {
                alert("Erro ao listar status! " + res.data[0].msg)
            }
        }
        catch(err){
            alert(err + " listar status")
        }
    }

    return (
        <select onChange={(e)=> props.selectstatus(e.target.value)} className="form-control">
            <option value="">Status...</option>
            { results && results.map( (results) => <option value={results.statusid}>{ results.status }</option>) }
        </select>
    )

}
    
export default Status;